import { render, staticRenderFns } from "./GoodsOdgList.vue?vue&type=template&id=42d788ff&"
import script from "./GoodsOdgList.vue?vue&type=script&lang=js&"
export * from "./GoodsOdgList.vue?vue&type=script&lang=js&"
import style0 from "./GoodsOdgList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/runner/work/myody_front/myody_front/components/button/Button.vue').default,GoodsOdgItem: require('/home/runner/work/myody_front/myody_front/components/goods/GoodsOdgItem.vue').default})
